var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout"},[_c('TheHeader'),_vm._v(" "),_c('div',{staticClass:"layout__content"},[_c('TheSubmenu',{attrs:{"root":_vm.submenuRoot,"urls":_vm.submenuUrls}}),_vm._v(" "),_c('Nuxt')],1),_vm._v(" "),_c('TheFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }